<div class="f-family-bold f-size-sm">{{ header }}</div>
<div class="media">
  <div class="date-card">
    <div class="f-family-bold mt-2 f-size-xl date">{{ date }}</div>
    <div class="month">{{ month }}</div>
  </div>
  <div class="media-body pl-2">
    <div>
      <ng-content select="span.extra-info"></ng-content>
    </div>
  </div>
</div>
